import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'send-email-warning',
    templateUrl: './send-email-warning-dialog.component.html',
    styleUrls: [
        './send-email-warning-dialog.component.css'
    ]
})
export class SendEmailWarningDialogComponent implements OnInit {

    // Injected Properties
    noSubject = true;
    noContent = true;

    // Class Functions
    constructor (
        private dialogBox: MatDialogRef<SendEmailWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {}

    // Event Functions
    ngOnInit() {
        // PRE: injected dialog data with the injected properties
        // POST: initializes the data
        this.noSubject = this.data.noSubject;
        this.noContent = this.data.noContent;
    }

    sendAnyway() {
        // PRE: the send anyway button is clicked
        // POST: closes the dialog box with true
        this.dialogBox.close(true);
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog box with false
        this.dialogBox.close(false);
    }

    // Methods
}